import { useState } from "react";
import { useRouter } from "next/router";
import { JoinSessionDialog } from "@/components/boardblend/join-session-dialog";
import styles from "./workshops.module.css";

export function WorkshopJoinButton() {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [roomCode, setRoomCode] = useState("");
  const [error, setError] = useState("");

  function join(code = roomCode) {
    if (code.length !== 6) {
      setError("Enter the six-character room code.");
      return;
    }
    void router.push(`/join/${code}`);
  }

  return (
    <>
      <button className={styles.secondary} onClick={() => setOpen(true)}>
        Join a workshop
      </button>
      {open && (
        <JoinSessionDialog
          kind="workshop"
          busy={false}
          error={error}
          roomCode={roomCode}
          onChange={(value) => {
            setRoomCode(value);
            setError("");
          }}
          onClose={() => {
            setOpen(false);
            setRoomCode("");
            setError("");
          }}
          onJoin={join}
        />
      )}
    </>
  );
}
